import feathers from '@feathersjs/feathers'
import rest from './rest'

const client = feathers().configure(rest)

client.getService = name => client.service(name)

export default client
